import _ from 'lodash';

export const userRoles = [
    { name: "Broker", id: "broker", external: true },
    { name: "Producer Support", id: "producersupport", external: true },
    { name: "Employer", id: "employer", external: true },
    { name: "Employer/Plan Admin", id: "planadmin", external: true },
    { name: "Employer/Admin Fee Invoicing", id: "adminfeeinvoicing", external: true },
    { name: "Employer/Claims Invoicing", id: "claimsinvoicing", external: true },
    { name: "Employer/Monthly Reporting", id: "monthlyreporting", external: true },
    { name: "Employer/Cobra Contact", id: "cobracontact", external: true },
    { name: "Employer/Invoice Details", id: "invoicedetails", external: true },
    { name: "Employer/Invoice Totals", id: "invoicetotals", external: true },
    { name: "Employer/Flex EDI", id: "flexedi", external: true },
    { name: "Employer/Cobra EDI", id: "cobraedi", external: true },
    { name: "Admin", id: "admin", external: false },
    { name: "CSS", id: "iss", external: false  },
    { name: "PSR", id: "msr", external: false  },
    { name: "QA", id: "qa", external: false  },
    { name: "Operations", id: "ops", external: false  },
    { name: "Accounting", id: "finance", external: false  },
    { name: "CRS", id: "ae", external: false  },
    { name: "Claims Processor", id: "claimsprocessor", external: false  },
    { name: "Compliance", id: "compliance", external: false  },
    { name: "Team Manager", id: "teammanager", external: false  },
    { name: "ePOP", id: "epop", external: false  },
];

export const actionItemUserRoles = [
  { name: "Employer Broker", id: "employer.broker", assignable: true, isExternal: true },
  { name: "Employer COBRA AE", id: "employer.cobraae", assignable: true },
  { name: "Employer Flex AE", id: "employer.flexae", assignable: true },
  { name: "Employer Plan Admin", id: "employer.planadmin", assignable: false, isExternal: true },
  { name: "Employer CSS", id: "employer.css", assignable: true },
  { name: "CSS", id: "iss", assignable: false },
  { name: "Operations", id: "ops", assignable: true },
  { name: "PSR", id: "msr", assignable: false  },
  { name: "QA", id: "qa", assignable: true },
  { name: "Compliance", id: "compliance", assignable: true },
  { name: "Accounting", id: "finance", assignable: true },
];

export const actionItemUserRolesMap = _.keyBy(actionItemUserRoles, 'id');
export const userRoleMap = _.keyBy(userRoles, 'id');





// WEBPACK FOOTER //
// ./src/user/user-labels.js